
/**
 * params required
 * action: acción a realizar: 1: new | 2 editar
 * params: {
 *  idperson: 
 *  idpayroll:
 * }
 */

import { defineComponent, ref, inject, reactive, onMounted } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { ElNotification } from 'element-plus'
//services
import masterService from "@/core/services/MasterService";
import allergyService from '@/core/services/AllergyService';
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "ModalAlergyPerson",
    props:{
        params: {
            type: null,
            required: true,
            default: ""
        },
        action: {
            type: Number,
            required: true,
            default: ""
        }
    },
    setup(props, {emit}) {
        const loader = ref(false)
        const dialogAlergy = inject<any>("dialogAlergy")
        const listAllergy = ref<any>([])
        const listSeverity = ref<any>([])
        const formRef = ref<FormInstance>()
        const formData = reactive(<any>{
            idperson : null,
            idallergy: null,
            idseverity: null,
            reactions: null,
            mstatus: null
        })
        const rules = reactive<FormRules>({})

        const getListAllergy = async() => {
            await masterService.Details("api", btoa("28"))
            .then((res)=>{
                listAllergy.value = res.data
            })
        }

        const getListSeverity = async() => {
            await masterService.Details("api", btoa("29"))
            .then((res)=>{
                listSeverity.value = res.data
            })
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if(!formEl) return;
            formEl.resetFields();
        }

        const submitForm = async (formEl: FormInstance | undefined) => {
            if(!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (props.action == 1)
                        onSave();
                    else
                        onUpdate();
                }
            });
        }

        const onOpen = () => {
            formData.idperson = ("idperson" in props.params) ? props.params.idperson : null
        }

        const onClosed = () => {
            resetForm(formRef.value)
        }

        const onSave = async() => {
            loader.value = true
            if(formData.idperson !=null){ //guardar en el servidor
                formData.idallergy = formData.idallergy.id
                formData.idseverity = formData.idseverity.id
                await allergyService.create(formData)
                .then((res)=>{
                    loader.value = false
                    ElNotification({
                        title: res.data.title,
                        message: res.data.message,
                        type: 'success',
                    })
                    if(res.data.status){
                        emit("onResponseAllergy", {status : true})
                        dialogAlergy.value = false
                    }
                }).catch(({response})=>{
                    loader.value = false
                    errManager(response)
                })
            } else {
                loader.value = false
                emit("onResponseAllergy", {status : false, params: {
                    idperson : formData.idperson,
                    idallergy: formData.idallergy,
                    idseverity: formData.idseverity,
                    reactions: formData.reactions,
                    mstatus: formData.mstatus
                }})
                dialogAlergy.value = false
            }
        }

        const onUpdate = () => {
            emit("onResponseAllergy", {status : true})
            //true: quiere decir que refresque la lista
        }

        onMounted(()=>{
            getListAllergy();
            getListSeverity();

        })

        return {
            loader,
            dialogAlergy,
            formRef,
            formData,
            rules,
            listAllergy,
            listSeverity,

            //events
            getListAllergy,
            getListSeverity,
            submitForm,
            resetForm,
            onClosed,
            onOpen
        }

    },
})
